import React, { Component } from 'react';
import {
  isMobile,
  isIOS,
  isSafari,
  isMacOs,
  isChrome,
  isDesktop,
} from 'react-device-detect';
import classes from './AgeStep.module.css';
import strings from '../../../../../assets/localization';
import Button from '../../../../UI/Button/Button';
import Input from '../../../../UI/Input/Input';
import InputError from '../../../../UI/InputError/InputError';
import StepHeader from '../StepHeader/StepHeader';
import { checkForCharactersInNumbers } from '../../../../../assets/helpers/utils';

export default class AgeStep extends Component {
  constructor(props) {
    super(props);
    this.textInput = React.createRef();
    this.state = { isEmpty: true, currentAge: '' };
  }

  // componentDidMount() {
  //   if (this.props.age === 0) {
  //     this.textInput.focus();
  //   }
  // }

  _handleKeyDown = (e) => {
    if (e.keyCode === 13 && this._validateAge()) {
      this.props.goToStep(4);
    }
  };

  _onChange = (e) => {
    const {
      target: { value },
    } = e;

    // console.log('VALUE:', value);

    const ageVal = parseInt(value);

    if (isDesktop) {
      // console.log('JESTE DESKTOP!!!');
      if (checkForCharactersInNumbers(value)) {
        // console.log('IMA NESTO ALI NISU BROJEVI!!');
        this.setState({ hasAgeError: true });
      } else {
        // console.log('AL IS GOOD!');
        this.setState({ hasAgeError: false });
      }
      this.props.setAge(value);
    } else {
      // console.log('NAJVEROVATIONE MOBILNI!!!!');
      this.props.setAge(parseInt(value));
    }

    const ageLength = value.length;
    if (ageLength === 2) {
      this.setState({ isEmpty: false });
    }
  };

  _validateAge = () => {
    const { minAge, maxAge, age } = this.props;

    return parseInt(age) >= minAge && parseInt(age) <= maxAge;
  };

  _renderAgeError = () => {
    const { isEmpty } = this.state;
    let ageError = this.state.hasAgeError
      ? strings.EnterYourAge
      : strings.ageError
          .replace('<', this.props.minAge)
          .replace('>', this.props.maxAge);

    return (
      <InputError
        style={{
          display:
            !isEmpty && (!this._validateAge() || this.state.hasAgeError)
              ? 'block'
              : 'none',
        }}
      >
        {ageError}
      </InputError>
    );
  };

  render() {
    // console.log('STEP 3 RENDER:', this.props, this.state);
    const { hideHeader, age, isLandscape } = this.props;
    let cssStyles =
      hideHeader && isMobile && isIOS
        ? [classes.StepFour, classes.StepFourSafari].join(' ')
        : classes.StepFour;
    let safariSafeHideHeader = isMobile && isIOS ? false : hideHeader;

    return (
      <div className={cssStyles}>
        <StepHeader
          hideHeader={!isLandscape && safariSafeHideHeader}
          headerText={strings.howOldAreYou}
          subheaderText={strings.enterAgeBelow}
          activeStep={3}
          pageCount={5}
        />
        <div className={classes.ContentWrapper}>
          <div className={classes.InputWrapper}>
            <Input
              setRef={(component) => {
                this.textInput = component;
              }}
              type={(isMacOs && isSafari) || isDesktop ? 'text' : 'number'}
              // pattern='[0-9]*'
              // digitOnly
              // numeric
              // inputmode='numeric'
              value={age !== 0 ? age : ''}
              onFocus={this.props.onFocus}
              onBlur={this.props.onBlur}
              onChange={this._onChange}
              onKeyDown={this._handleKeyDown}
              label={strings.ageLabel}
              placeholder={strings.agePlaceholder}
              maxLength={2}
            />
            {this._renderAgeError()}
          </div>
          <div
            className={classes.Footer}
            style={{
              justifyContent:
                isIOS && !isLandscape && (isSafari || isChrome)
                  ? 'flex-start'
                  : 'flex-end',
            }}
          >
            <Button
              disabled={!this._validateAge()}
              clicked={this.props.goToStep.bind(this, 4)}
            >
              {strings.next}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Auth/EmailRegister/Steps/AgeStep/AgeStep.js